import { Color } from '@/app/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'c-button-add-global',
    templateUrl: './button-add.component.html',
    styleUrl: './button-add.component.css',
    standalone: false
})
export class ButtonAddGlobalComponent {
  @Input() width!: number;
  @Input() idButton!: string;
  @Input() text!: string;
  @Input() base: boolean = true;
  wClass = '';
  @Input() color: Color = 'primary';
  ngOnInit() {
    this.wClass = `hover:w-[${this.width}px]`;
  }
  @Output() clickBtn = new EventEmitter<boolean>();
  getClick() {
    this.clickBtn.emit(true);
  }
}
